import { DocumentType } from "./enumerations/document-type.model";
import { ProblemType } from "./enumerations/problem-type-model";

export interface IProblem {
  id?: number;
  firstName?: string;
  lastName?: string;
  document?: string;
  documentType?: string;
  mail?: string;
  reason?: string;
  message?: string;
}

export const defaultValue: Readonly<IProblem> = {};

export const initialValuesProblem: IProblem = {
  firstName: "",
  lastName: "",
  document: "",
  documentType: DocumentType.ID,
  mail: "",
  reason: ProblemType.WRONG_DATA,
  message: "",
};
